/**
 * The one description of the dashboard's sections and views: the
 * sidebar menu, the home page tiles and the top bar title/add button
 * all render from these tables.
 */

export const CATEGORIES = [
	{ 'id': 0, 'name': 'User', 'label': 'Personen', 'icon': 'account' },
	{ 'id': 1, 'name': 'Facilities', 'label': 'Einrichtungen', 'icon': 'account' },
	{ 'id': 2, 'name': 'Finance', 'label': 'Finanzen', 'icon': 'account' },
	{ 'id': 3, 'name': 'Documents', 'label': 'Dokumente', 'icon': 'account' },
	{ 'id': 4, 'name': 'Medication', 'label': 'Medikation', 'icon': 'medication' },
	//{ 'id': 5, 'name': 'Data', 'label': 'Daten', 'icon': 'account' },
	{ 'id': 6, 'name': 'Etc', 'label': 'Sonstiges', 'icon': 'view-dashboard' }
];

export const NAV_ITEMS = [
	{ 'id': 0, 'name': 'Users', 'label': 'Nutzer', 'icon': 'account-plus', 'tag': 'router-link', 'path': '/users', 'cat': 'User' },
	{ 'id': 1, 'name': 'Groups', 'label': 'Gruppen', 'icon': 'account-group', 'tag': 'router-link', 'path': '/groups', 'cat': 'User' },
	{ 'id': 2, 'name': 'Clients', 'label': 'Klienten', 'icon': 'account-child', 'tag': 'router-link', 'path': '/clients', 'cat': 'User' },
	{ 'id': 3, 'name': 'External', 'label': 'Externe', 'icon': 'account-plus', 'tag': 'router-link', 'path': '/externals', 'cat': 'User' },
	{ 'id': 4, 'name': 'Diary', 'label': 'Tagebuch', 'icon': 'book-open-variant', 'tag': 'router-link', 'path': '/diary', 'cat': 'Documents' },
	{ 'id': 5, 'name': 'ClientRecords', 'label': 'Kinderakte', 'icon': 'text-box', 'tag': 'router-link', 'path': '/client_records', 'cat': 'Documents' },
	{ 'id': 6, 'name': 'Districts', 'label': 'Landkreise', 'icon': 'map-marker-radius', 'tag': 'router-link', 'path': '/districts', 'cat': 'Facilities' },
	{ 'id': 7, 'name': 'persons', 'label': 'Personen', 'icon': 'account-child', 'tag': 'router-link', 'path': '/persons', 'cat': 'User' },
	{ 'id': 8, 'name': 'socialWorker', 'label': 'Sozialarbeiter', 'icon': 'account-tie', 'tag': 'router-link', 'path': '/socialWorker', 'cat': 'User' },
	{ 'id': 9, 'name': 'school', 'label': 'Schule/Kindergarten', 'icon': 'school', 'tag': 'router-link', 'path': '/schools', 'cat': 'Facilities' },
	{ 'id': 10, 'name': 'statutoryBasis', 'label': 'Gesetzliche Grundlage', 'icon': 'scale-balance', 'tag': 'router-link', 'path': '/statutoryBasis', 'cat': 'Documents' },
	{ 'id': 11, 'name': 'reportTemplates', 'label': 'Berichtsvorlagen', 'icon': 'book', 'tag': 'router-link', 'path': '/report_templates', 'cat': 'Documents' },
	{ 'id': 12, 'name': 'balance', 'label': 'Kassen', 'icon': 'account-cash', 'tag': 'router-link', 'path': '/balance_overview', 'cat': 'Finance' },
	{ 'id': 13, 'name': 'education_fields', 'label': 'Wochenplan', 'icon': 'calendar-week', 'tag': 'router-link', 'path': '/education_fields', 'cat': 'Documents' },

	{ 'id': 15, 'name': 'licenseKind', 'label': 'Bewilligungstyp', 'icon': 'book-information-variant', 'tag': 'router-link', 'path': '/license_kind', 'cat': 'Documents' },

	{ 'id': 16, 'name': 'medication', 'label': 'Medikamente', 'icon': 'medication', 'tag': 'router-link', 'path': '/medication', 'cat': 'Medication' },
	{ 'id': 17, 'name': 'medication_form', 'label': 'Darreichungsform (Art)', 'icon': 'medical-bag', 'tag': 'router-link', 'path': '/medication_form', 'cat': 'Medication' },
	{ 'id': 18, 'name': 'medication_unit', 'label': 'Darreichungsform (Einheit)', 'icon': 'medical-bag', 'tag': 'router-link', 'path': '/medication_unit', 'cat': 'Medication' },
	{ 'id': 19, 'name': 'doctor', 'label': 'Ärzte', 'icon': 'doctor', 'tag': 'router-link', 'path': '/doctor', 'cat': 'Medication' },
	{ 'id': 20, 'name': 'diagnose', 'label': 'Diagnosen', 'icon': 'doctor', 'tag': 'router-link', 'path': '/diagnose', 'cat': 'Medication' },
	{ 'id': 21, 'name': 'icd_10_code', 'label': 'ICD-10-Codes', 'icon': 'medical-bag', 'tag': 'router-link', 'path': '/icd_10', 'cat': 'Medication' },
	{ 'id': 22, 'name': 'instant_medication', 'label': 'Bedarfsmedikamente', 'icon': 'medication', 'tag': 'router-link', 'path': '/instant_medication', 'cat': 'Medication' },
	{ 'id': 23, 'name': 'DataImport', 'label': 'Daten Import', 'icon': 'database-import', 'tag': 'router-link', 'path': '/data_import', 'cat': 'Data' },
	{ 'id': 24, 'name': 'DataExport', 'label': 'Daten Export', 'icon': 'database-export', 'tag': 'router-link', 'path': '/data_export', 'cat': 'Data' },
	{ 'id': 25, 'name': 'DataProtection', 'label': 'Datenschutz', 'icon': 'shield', 'tag': 'router-link', 'path': '/dataprotection', 'cat': 'Etc' },
	{ 'id': 26, 'name': 'Imprint', 'label': 'Impressum', 'icon': 'help-circle', 'tag': 'router-link', 'path': '/imprint', 'cat': 'Etc' },
	{ 'id': 27, 'name': 'Widget', 'label': 'Widgets', 'icon': 'shield', 'tag': 'router-link', 'path': '/widgets', 'cat': 'Etc' }
];

export const ROUTE_TAB_MAP = {
	Users: "Users", AddUser: "Users", ViewUser: "Users",
	Groups: "Groups", AddGroup: "Groups", ViewGroup: "Groups",
	Clients: "Clients", AddClient: "Clients", ViewClient: "Clients",
	Externals: "External", EditExternal: "External", ViewExternal: "External",
	Persons: "persons", AddPerson: "persons", ViewPerson: "persons",
	SocialWorkers: "socialWorker", AddSocialWorker: "socialWorker",
	ViewSocialWorker: "socialWorker",
	Schools: "school", AddSchool: "school", ViewSchool: "school",
	Districts: "Districts", AddDistrict: "Districts",
	ViewDistrict: "Districts",
	diary: "Diary",
	ClientRecords: "ClientRecords", AddClientRecords: "ClientRecords",
	EditClientRecords: "ClientRecords", ViewClientRecords: "ClientRecords",
	EditFocusedClientRecords: "ClientRecords", EditPdf: "ClientRecords",
	StatutoryBasis: "statutoryBasis", AddStatutoryBasis: "statutoryBasis",
	ReportTemplates: "reportTemplates",
	AddReportTemplate: "reportTemplates",
	BalanceOverview: "balance", AddBalanceGroup: "balance",
	ViewBalanceGroup: "balance",
	EducationFields: "education_fields",
	AddEducationField: "education_fields",
	LicenseKind: "licenseKind", AddLicenseKind: "licenseKind",
	ViewLicenseKind: "licenseKind",
	Medication: "medication", AddMedication: "medication",
	ViewMedication: "medication",
	MedicationForm: "medication_form",
	AddNewMedicationForm: "medication_form",
	ViewMedicationForm: "medication_form",
	MedicationUnit: "medication_unit",
	AddNewMedicationUnit: "medication_unit",
	ViewMedicationUnit: "medication_unit",
	Doctor: "doctor", AddDoctor: "doctor", ViewDoctor: "doctor",
	Diagnose: "diagnose", AddDiagnose: "diagnose",
	ViewDiagnose: "diagnose",
	ICD10: "icd_10_code", AddICD10: "icd_10_code",
	ViewICD10: "icd_10_code",
	InstantMedication: "instant_medication",
	AddInstantMedication: "instant_medication",
	ViewInstantMedication: "instant_medication",
	DataImport: "DataImport", DataExport: "DataExport",
	DataProtection: "DataProtection", Imprint: "Imprint",
	WidgetOverview: "Widget", NewWidget: "Widget", EditWidget: "Widget",
};

/**
 * List-view route => its nav item (for the title) and the route the
 * top bar "+" navigates to. Detail routes are absent on purpose, they
 * keep their in-page panels.
 */
export const LIST_ROUTES = {
	Users:             { item: "Users", add: "AddUser" },
	Groups:            { item: "Groups", add: "AddGroup" },
	Clients:           { item: "Clients", add: "AddClient" },
	Externals:         { item: "External", add: "AddExternal" },
	diary:             { item: "Diary" },
	ClientRecords:     { item: "ClientRecords", add: "AddClientRecords" },
	Districts:         { item: "Districts", add: "AddDistrict" },
	Persons:           { item: "persons", add: "AddPerson" },
	SocialWorkers:     { item: "socialWorker", add: "AddSocialWorker" },
	Schools:           { item: "school", add: "AddSchool" },
	StatutoryBasis:    { item: "statutoryBasis", add: "AddStatutoryBasis" },
	ReportTemplates:   { item: "reportTemplates", add: "AddReportTemplate" },
	BalanceOverview:   { item: "balance", add: "AddBalanceGroup" },
	EducationFields:   { item: "education_fields", add: "AddEducationField" },
	LicenseKind:       { item: "licenseKind", add: "AddLicenseKind" },
	Medication:        { item: "medication", add: "AddMedication" },
	MedicationForm:    { item: "medication_form", add: "AddNewMedicationForm" },
	MedicationUnit:    { item: "medication_unit", add: "AddNewMedicationUnit" },
	Doctor:            { item: "doctor", add: "AddDoctor" },
	Diagnose:          { item: "diagnose", add: "AddDiagnose" },
	ICD10:             { item: "icd_10_code", add: "AddICD10" },
	InstantMedication: { item: "instant_medication", add: "AddInstantMedication" },
	DataImport:        { item: "DataImport" },
	DataExport:        { item: "DataExport" },
	DataProtection:    { item: "DataProtection" },
	Imprint:           { item: "Imprint" },
	WidgetOverview:    { item: "Widget", add: "NewWidget" },
};

/** The nav item a list route shows, with its label and add target. */
export function sectionForRoute(routeName) {
	const entry = LIST_ROUTES[routeName];
	if (!entry) return undefined;
	const item = NAV_ITEMS.find((i) => i.name === entry.item);
	return { label: item ? item.label : routeName, add: entry.add };
}

/**
 * For a detail route (ViewClient, AddUser, ...): the section label as
 * fallback title and the list route the back chevron returns to.
 */
export function detailForRoute(routeName) {
	if (LIST_ROUTES[routeName]) return undefined;
	const itemName = ROUTE_TAB_MAP[routeName];
	if (!itemName) return undefined;
	const listEntry = Object.entries(LIST_ROUTES)
		.find(([ , v ]) => v.item === itemName);
	const item = NAV_ITEMS.find((i) => i.name === itemName);
	return {
		label: item ? item.label : routeName,
		list: listEntry ? listEntry[0] : undefined,
	};
}
